import React, { useState, useEffect } from 'react';
import styles from './Dashboard.module.css';

const PDFViewer = () => {
  const [pdfs, setPdfs] = useState([]);
  const [selectedPdf, setSelectedPdf] = useState(null);
  const [loading, setLoading] = useState(false);

  // TODO: AWS S3'ten PDF listesi çekilecek
  useEffect(() => {
    // Mock data
    setPdfs([
      { id: 1, name: 'Haftalık Rapor - 2024-01-15.pdf', date: '2024-01-15', type: 'Weekly' },
      { id: 2, name: 'Su Tüketim Raporu - 2024-01-10.pdf', date: '2024-01-10', type: 'Water Consumption' },
      { id: 3, name: 'Performans Raporu - 2024-01-05.pdf', date: '2024-01-05', type: 'Performance' },
    ]);
  }, []);

  const handleViewPdf = async (pdf) => {
    setLoading(true);
    try {
      // TODO: AWS S3'ten PDF'i çek ve göster
      // const pdfUrl = await getPdfFromS3(pdf.id);
      // setSelectedPdf({ ...pdf, url: pdfUrl });
      
      // Mock: Şimdilik sadece PDF adını göster
      setSelectedPdf(pdf);
    } catch (error) {
      console.error('PDF yükleme hatası:', error);
      alert('PDF yüklenirken bir hata oluştu');
    } finally {
      setLoading(false);
    }
  };

  const handleDownloadPdf = async (pdf) => {
    try {
      // TODO: AWS S3'ten PDF'i indir
      // await downloadPdfFromS3(pdf.id);
      alert(`${pdf.name} indiriliyor...`);
    } catch (error) {
      console.error('PDF indirme hatası:', error);
      alert('PDF indirilirken bir hata oluştu');
    }
  };

  return (
    <div className={styles.pdfViewer}>
      <div className={styles.pdfViewerHeader}>
        <h2>PDF Çıktılar</h2>
        <p>Önceki raporları görüntüleyin ve indirin</p>
      </div>

      <div className={styles.pdfList}>
        {pdfs.map(pdf => (
          <div key={pdf.id} className={styles.pdfItem}>
            <div className={styles.pdfInfo}>
              <h3>{pdf.name}</h3>
              <p>Tarih: {pdf.date} | Tip: {pdf.type}</p>
            </div>
            <div className={styles.pdfActions}>
              <button
                className={styles.viewButton}
                onClick={() => handleViewPdf(pdf)}
                disabled={loading}
              >
                Görüntüle
              </button>
              <button
                className={styles.downloadButton}
                onClick={() => handleDownloadPdf(pdf)}
              >
                İndir
              </button>
            </div>
          </div>
        ))}
      </div>

      {selectedPdf && (
        <div className={styles.pdfModal}>
          <div className={styles.modalContent}>
            <div className={styles.modalHeader}>
              <h3>{selectedPdf.name}</h3>
              <button onClick={() => setSelectedPdf(null)}>✕</button>
            </div>
            <div className={styles.pdfContainer}>
              {/* TODO: PDF viewer component ekle */}
              <iframe
                src={`/pdfs/${selectedPdf.id}`}
                title={selectedPdf.name}
                style={{ width: '100%', height: '600px', border: 'none' }}
              />
              <p className={styles.pdfPlaceholder}>
                PDF görüntüleyici buraya eklenecek. AWS S3'ten PDF URL'i alınacak.
              </p>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default PDFViewer;

